import React, { useState } from "react";
import Header from '../modules/Header';
import { Whatabkt_explain } from '../modules/Whatabkt_explain';

export const Whatabkt = () => {
    return (
        <>
            <Whatabkt_explain/>
        </>
    );
};